import { ContractStatuses, ContractTypes } from 'domain/models/ContractsModel'

export default function Utils() {
  const convertContractObjToExpectedFormatContext = (contractData: any) => {
    // Handle both direct contract object and the wrapped response from backend
    const contract = contractData.contract || contractData
    const payments = contractData.payments || contractData.payment_parts || []

    const cpfOrCnpjList =
      contract.buyers
        ?.map((buyer: any) => {
          const cpfOrCnpj = buyer.info?.cpf || buyer.info?.cnpj
          return cpfOrCnpj
        })
        .filter(Boolean) || []

    return {
      company_id: contract.company_id,
      deadline_allows_modify_unit: contract.deadline_allows_modify_unit,
      buyers: contract.buyers?.map((buyer: any) => buyer.id) || [],
      spe_id: contract.spe_id,
      project_id: contract.project_id,
      unit_id: contract.unit_id,
      value: contract.value,
      discount_rate: contract.discount_rate,
      billing_person_id: contract.billing_person_id,
      id: contract.id,
      is_tokenized: contract.is_tokenized,
      type: contract.type,
      status: contract.status,
      created_id: contract.id,
      business_name: contract.company?.business_name,
      cpfOrCnpjList: cpfOrCnpjList,
      payment_parts: payments,
      uau_vendedor_code: contract.uau_vendedor_code,
      uau_modelo_comissao_code: contract.uau_modelo_comissao_code,
      edited_minuta_html: contract.edited_minuta_html ?? null,
      company_is_signing: contract.company_is_signing,
      custom_contract: !!contract.custom_contract_url
    }
  }
  return {
    convertContractObjToExpectedFormatContext
  }
}

export interface contractAutoFill {
  company?: any
  company_id: string
  deadline_allows_modify_unit: Date
  buyers: any[]
  spe_id: string
  project_id: string
  unit_id: string
  value: number
  discount_rate: number
  billing_person_id: string
  id: string
  is_tokenized: boolean
  type: ContractTypes
  status: ContractStatuses
  created_id: Date
  business_name: any
  cpfOrCnpjList: any[]
  payment_parts?: any[]
  uau_vendedor_code?: string
}
